'use client';

import { SearchEngine, buildQuerySummary } from '@coveo/atomic-react';
import { useEffect, useState } from 'react';

export const useQuerySummary = (searchEngine: SearchEngine<{}> | undefined) => {
  const [searchBoxController] = useState(
    searchEngine && buildQuerySummary(searchEngine)
  );
  const [searchBoxState, setSearchBoxState] = useState(
    searchBoxController?.state
  );

  useEffect(() => {
    searchBoxController?.subscribe(() =>
      setSearchBoxState(searchBoxController.state)
    );
  }, [searchBoxController]);
  return {
    searchBoxState,
  };
};
